import {
  RECEIVED_USERS,
  RECEIVED_USER,
  CREATED_USER,
  UPDATED_USER,
  DELETED_USER,
  RECEIVING_USERS,
  RECEIVING_USER,
  UPDATING_USER,
  DELETING_USER,
  FAILURE_USER,
  SET_ROLE_ID,
  RECEIVING_EMPLOYEE_SALES,
  RECEIVED_EMPLOYEE_SALES,
  CLEAR_EMPLOYEE_SALES,
  SET_SELECTED_EMPLOYEE,
  RECEIVING_PAYOUT_STATUS,
  RECEIVED_PAYOUT_STATUS,
  RECEIVING_PAYOUT_HISTORY,
  RECEIVED_PAYOUT_HISTORY,
  RETRYING_PAYOUT,
  RETRY_PAYOUT_COMPLETE,
  TRIGGERING_PAYOUT,
  TRIGGER_PAYOUT_COMPLETE,
    RETRYING_FAILED_TRANSFERS,
    RETRY_FAILED_TRANSFERS_COMPLETE,
  SKIPPING_TRANSFERS,
  SKIP_TRANSFERS_COMPLETE,
  RECLAIMING_TRANSFERS,
  RECLAIM_TRANSFERS_COMPLETE,
  RECLAIMING_TO_PLATFORM,
  RECLAIM_TO_PLATFORM_COMPLETE,
  PROCESSING_HELD_REVERSALS,
  PROCESS_HELD_REVERSALS_COMPLETE,
  UPDATE_SALE_PAYOUT_STATUS,
  RECEIVING_TIP_FUNDING_SUMMARY,
  RECEIVED_TIP_FUNDING_SUMMARY
} from '../actions/users';

const defaultState = {
    roles: [],
    data: [],
    curRoleId: 1,
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    error: "",
    // Employee sales state
    employeeSales: [],
    employeeSalesLoading: false,
    employeeSalesSummary: null,
    selectedEmployee: null,
    // Payout state
    payoutStatus: null,
    payoutStatusLoading: false,
    payoutHistory: null,
    payoutHistoryLoading: false,
    retryingTransferId: null,
    triggeringSaleId: null,
    retryingFailedWorkPeriodId: null,
    skippingTransfersWorkPeriodId: null,
    reclaimingTransfersWorkPeriodId: null,
    reclaimingToPlatformWorkPeriodId: null,
    processingHeldWorkPeriodId: null,
    payoutAttemptResultsByWorkPeriodId: {},
    tipFundingSummary: null,
    tipFundingSummaryLoading: false,
    tipFundingSummaryError: ''
};

export default function usersReducer(state = defaultState, action) {
    switch (action.type) {
        case RECEIVED_USERS:
            return Object.assign({}, state, {
                data: Array.isArray(action.payload?.users) ? action.payload.users : [],
                roles: Array.isArray(action.payload?.roles) ? action.payload.roles : [],
                isReceiving: false,
                error: "",
            });
        case RECEIVED_USER:
            return Object.assign({}, state, {
                data: [...state.data, action.payload],
                isReceiving: false,
            });
        case CREATED_USER:
            return Object.assign({}, state, {
                data: [...state.data, action.payload],
                isUpdating: false,
            });
        case UPDATED_USER:
            let index = state.data.findIndex(p => p.UserId === action.payload.UserId);
            return Object.assign({}, state, {
                data: state.data.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, action.payload);
                    }
                    return p;
                }),
                isUpdating: false,
            });
        case DELETED_USER:
            let indexToDelete = state.data.findIndex(p => p.UserId === action.payload);
            let data = [...state.data];
            data.splice(indexToDelete, 1);
            return Object.assign({}, state, {
                data: [...data],
                isDeleting: false,
                idToDelete: null
            });
        case RECEIVING_USERS:
        case RECEIVING_USER:
            return Object.assign({}, state, {
                isReceiving: true
            });
        case UPDATING_USER:
            return Object.assign({}, state, {
                isUpdating: true
            });
        case DELETING_USER:
            return Object.assign({}, state, {
                isDeleting: true,
                idToDelete: action.payload
            });
        case FAILURE_USER:
            return Object.assign({}, state, {
                error: action.payload,
                isReceiving: false,
                isUpdating: false,
                isDeleting: false
            });
        case SET_ROLE_ID:
            return Object.assign({}, state, {
                curRoleId: action.payload,
            });
        case RECEIVING_EMPLOYEE_SALES:
            return Object.assign({}, state, {
                employeeSalesLoading: true
            });
        case RECEIVED_EMPLOYEE_SALES:
            return Object.assign({}, state, {
                employeeSales: Array.isArray(action.payload)
                    ? action.payload
                    : (action.payload?.sales || []),
                employeeSalesSummary: Array.isArray(action.payload)
                    ? null
                    : (action.payload?.summary || null),
                employeeSalesLoading: false
            });
        case CLEAR_EMPLOYEE_SALES:
            return Object.assign({}, state, {
                employeeSales: [],
                employeeSalesSummary: null,
                employeeSalesLoading: false,
                selectedEmployee: null,
                retryingFailedWorkPeriodId: null,
                skippingTransfersWorkPeriodId: null,
                reclaimingTransfersWorkPeriodId: null,
                reclaimingToPlatformWorkPeriodId: null,
                processingHeldWorkPeriodId: null,
                payoutAttemptResultsByWorkPeriodId: {}
            });
        case SET_SELECTED_EMPLOYEE:
            return Object.assign({}, state, {
                selectedEmployee: action.payload
            });
        case RECEIVING_PAYOUT_STATUS:
            return Object.assign({}, state, {
                payoutStatusLoading: true,
                payoutStatusLoadingUserId: action.payload?.userId || null
            });
        case RECEIVED_PAYOUT_STATUS:
            return Object.assign({}, state, {
                payoutStatus: action.payload,
                payoutStatusLoading: false,
                payoutStatusLoadingUserId: null
            });
        case RECEIVING_PAYOUT_HISTORY:
            return Object.assign({}, state, {
                payoutHistoryLoading: true
            });
        case RECEIVED_PAYOUT_HISTORY:
            return Object.assign({}, state, {
                payoutHistory: action.payload,
                payoutHistoryLoading: false
            });
        case RETRYING_PAYOUT:
            return Object.assign({}, state, {
                retryingTransferId: action.payload
            });
        case RETRY_PAYOUT_COMPLETE:
            return Object.assign({}, state, {
                retryingTransferId: null
            });
        case TRIGGERING_PAYOUT:
            return Object.assign({}, state, {
                triggeringSaleId: action.payload
            });
        case TRIGGER_PAYOUT_COMPLETE:
            return Object.assign({}, state, {
                triggeringSaleId: null
            }, action.payload?.workPeriodId ? {
                payoutAttemptResultsByWorkPeriodId: {
                    ...state.payoutAttemptResultsByWorkPeriodId,
                    [String(action.payload.workPeriodId)]: action.payload.payoutResult || null,
                }
            } : {});
        case RETRYING_FAILED_TRANSFERS:
            return Object.assign({}, state, {
                retryingFailedWorkPeriodId: action.payload
            });
        case RETRY_FAILED_TRANSFERS_COMPLETE:
            return Object.assign({}, state, {
                retryingFailedWorkPeriodId: null
            }, action.payload?.workPeriodId ? {
                payoutAttemptResultsByWorkPeriodId: {
                    ...state.payoutAttemptResultsByWorkPeriodId,
                    [String(action.payload.workPeriodId)]: action.payload.payoutResult || null,
                }
            } : {});
        case SKIPPING_TRANSFERS:
            return Object.assign({}, state, {
                skippingTransfersWorkPeriodId: action.payload
            });
        case SKIP_TRANSFERS_COMPLETE: {
            const wpKey = action.payload?.workPeriodId ? String(action.payload.workPeriodId) : null;
            const skippedIds = Array.isArray(action.payload?.skippedTransferIds) ? action.payload.skippedTransferIds : [];
            const baseState = Object.assign({}, state, { skippingTransfersWorkPeriodId: null });
            if (!wpKey || !action.payload?.success) return baseState;
            // Clear merchant-funded entries on the existing payout attempt result.
            const existing = state.payoutAttemptResultsByWorkPeriodId[wpKey];
            const remainingIds = (existing?.merchantFundedTransferIds || [])
                .filter(id => !skippedIds.includes(id) && !skippedIds.includes(Number(id)));
            const updated = existing ? {
                ...existing,
                merchantFundedCount: remainingIds.length,
                merchantFundedTransferIds: remainingIds,
                hasMerchantFundedTransfers: remainingIds.length > 0,
                merchantFundedAmount: remainingIds.length === 0 ? 0 : existing.merchantFundedAmount,
                pendingTransfersAvailable: Math.max(0, (existing.pendingTransfersAvailable || 0) - skippedIds.length),
                transfersPending: Math.max(0, (existing.transfersPending || 0) - skippedIds.length),
                message: action.payload?.message || (remainingIds.length === 0 ? 'Marked as paid.' : existing.message),
                noUnpaidTransfers: !!action.payload?.noUnpaidTransfers,
                manualPayReason: action.payload?.manualPayReason !== undefined
                    ? action.payload.manualPayReason
                    : (existing.manualPayReason ?? null),
            } : {
                message: action.payload?.message || '',
                noUnpaidTransfers: !!action.payload?.noUnpaidTransfers,
                merchantFundedCount: 0,
                merchantFundedTransferIds: [],
                hasMerchantFundedTransfers: false,
                merchantFundedAmount: 0,
                pendingTransfersAvailable: 0,
                transfersPending: 0,
                manualPayReason: action.payload?.manualPayReason ?? null,
            };
            return Object.assign({}, baseState, {
                payoutAttemptResultsByWorkPeriodId: {
                    ...state.payoutAttemptResultsByWorkPeriodId,
                    [wpKey]: updated,
                }
            });
        }
        case RECLAIMING_TRANSFERS:
            return Object.assign({}, state, {
                reclaimingTransfersWorkPeriodId: action.payload
            });
        case RECLAIM_TRANSFERS_COMPLETE: {
            const wpKey = action.payload?.workPeriodId ? String(action.payload.workPeriodId) : null;
            const baseState = Object.assign({}, state, { reclaimingTransfersWorkPeriodId: null });
            if (!wpKey) return baseState;
            const existing = state.payoutAttemptResultsByWorkPeriodId[wpKey];
            if (!existing) return baseState;
            const completed = action.payload?.completed || 0;
            const failed = action.payload?.failed || 0;
            const heldIds = Array.isArray(action.payload?.heldTransferIds) ? action.payload.heldTransferIds : [];
            // Successful reclaim+transfer removes those IDs from merchantFunded and adds to completed.
            // Held IDs remain "owned" but move into the held bucket instead.
            const processedIds = Array.isArray(action.payload?.processedTransferIds) ? action.payload.processedTransferIds : [];
            const remainingMerchantIds = (existing.merchantFundedTransferIds || [])
                .filter(id => !processedIds.includes(id) && !processedIds.includes(Number(id)));
            const mergedHeldIds = Array.from(new Set([
                ...(existing.heldTransferIds || []).map(Number),
                ...heldIds.map(Number),
            ])).filter(id => Number.isFinite(id));
            const updated = {
                ...existing,
                transfersCompleted: (existing.transfersCompleted || 0) + completed,
                transfersFailed: (existing.transfersFailed || 0) + failed,
                pendingTransfersAvailable: Math.max(0, (existing.pendingTransfersAvailable || 0) - completed - failed),
                transfersPending: Math.max(0, (existing.transfersPending || 0) - completed - failed),
                failedTransfersAvailable: (existing.failedTransfersAvailable || 0) + failed,
                canRetryFailedTransfers: failed > 0 || existing.canRetryFailedTransfers,
                merchantFundedCount: remainingMerchantIds.length,
                merchantFundedTransferIds: remainingMerchantIds,
                hasMerchantFundedTransfers: remainingMerchantIds.length > 0,
                merchantFundedAmount: remainingMerchantIds.length === 0 ? 0 : existing.merchantFundedAmount,
                heldCount: mergedHeldIds.length,
                heldTransferIds: mergedHeldIds,
                hasHeldTransfers: mergedHeldIds.length > 0,
                heldAmount: mergedHeldIds.length > 0
                    ? ((existing.heldAmount || 0) + (action.payload?.heldAmount || 0))
                    : 0,
            };
            return Object.assign({}, baseState, {
                payoutAttemptResultsByWorkPeriodId: {
                    ...state.payoutAttemptResultsByWorkPeriodId,
                    [wpKey]: updated,
                }
            });
        }
        case RECLAIMING_TO_PLATFORM:
            return Object.assign({}, state, {
                reclaimingToPlatformWorkPeriodId: action.payload
            });
        case RECLAIM_TO_PLATFORM_COMPLETE: {
            const wpKey = action.payload?.workPeriodId ? String(action.payload.workPeriodId) : null;
            const baseState = Object.assign({}, state, { reclaimingToPlatformWorkPeriodId: null });
            if (!wpKey) return baseState;
            const existing = state.payoutAttemptResultsByWorkPeriodId[wpKey];
            if (!existing) return baseState;
            const heldIds = Array.isArray(action.payload?.heldTransferIds) ? action.payload.heldTransferIds : [];
            const processedIds = Array.isArray(action.payload?.processedTransferIds) ? action.payload.processedTransferIds : [];
            // Successful reclaim removes those IDs from merchantFunded — but they
            // remain "pending" awaiting employee payout, so do NOT increment
            // transfersCompleted/Failed yet. Held IDs move to the held bucket.
            const remainingMerchantIds = (existing.merchantFundedTransferIds || [])
                .filter(id => !processedIds.includes(id) && !processedIds.includes(Number(id)));
            const mergedHeldIds = Array.from(new Set([
                ...(existing.heldTransferIds || []).map(Number),
                ...heldIds.map(Number),
            ])).filter(id => Number.isFinite(id));
            const updated = {
                ...existing,
                merchantFundedCount: remainingMerchantIds.length,
                merchantFundedTransferIds: remainingMerchantIds,
                hasMerchantFundedTransfers: remainingMerchantIds.length > 0,
                merchantFundedAmount: remainingMerchantIds.length === 0 ? 0 : existing.merchantFundedAmount,
                heldCount: mergedHeldIds.length,
                heldTransferIds: mergedHeldIds,
                hasHeldTransfers: mergedHeldIds.length > 0,
                heldAmount: mergedHeldIds.length > 0
                    ? ((existing.heldAmount || 0) + (action.payload?.heldAmount || 0))
                    : 0,
            };
            return Object.assign({}, baseState, {
                payoutAttemptResultsByWorkPeriodId: {
                    ...state.payoutAttemptResultsByWorkPeriodId,
                    [wpKey]: updated,
                }
            });
        }
        case PROCESSING_HELD_REVERSALS:
            return Object.assign({}, state, {
                processingHeldWorkPeriodId: action.payload
            });
        case PROCESS_HELD_REVERSALS_COMPLETE: {
            const wpKey = action.payload?.workPeriodId ? String(action.payload.workPeriodId) : null;
            const baseState = Object.assign({}, state, { processingHeldWorkPeriodId: null });
            if (!wpKey) return baseState;
            const existing = state.payoutAttemptResultsByWorkPeriodId[wpKey];
            if (!existing) return baseState;
            const completed = action.payload?.completed || 0;
            const failed = action.payload?.failed || 0;
            const stillHeld = action.payload?.stillHeld || 0;
            const processedIds = Array.isArray(action.payload?.processedTransferIds) ? action.payload.processedTransferIds : [];
            // Held IDs that were attempted: drop from heldTransferIds. Those still held remain in the bucket but the count reflects backend truth.
            const remainingHeldIds = (existing.heldTransferIds || [])
                .filter(id => !processedIds.includes(id) && !processedIds.includes(Number(id)));
            const updated = {
                ...existing,
                transfersCompleted: (existing.transfersCompleted || 0) + completed,
                transfersFailed: (existing.transfersFailed || 0) + failed,
                failedTransfersAvailable: (existing.failedTransfersAvailable || 0) + failed,
                canRetryFailedTransfers: failed > 0 || existing.canRetryFailedTransfers,
                heldCount: stillHeld > 0 ? stillHeld : remainingHeldIds.length,
                heldTransferIds: remainingHeldIds,
                hasHeldTransfers: stillHeld > 0 || remainingHeldIds.length > 0,
                heldAmount: (stillHeld === 0 && remainingHeldIds.length === 0) ? 0 : existing.heldAmount,
            };
            return Object.assign({}, baseState, {
                payoutAttemptResultsByWorkPeriodId: {
                    ...state.payoutAttemptResultsByWorkPeriodId,
                    [wpKey]: updated,
                }
            });
        }
        case RECEIVING_TIP_FUNDING_SUMMARY:
            return Object.assign({}, state, {
                tipFundingSummaryLoading: true,
                tipFundingSummaryError: ''
            });
        case RECEIVED_TIP_FUNDING_SUMMARY:
            return Object.assign({}, state, {
                tipFundingSummaryLoading: false,
                tipFundingSummary: action.payload?.summary || null,
                tipFundingSummaryError: action.payload?.error || ''
            });
        case UPDATE_SALE_PAYOUT_STATUS:
            return Object.assign({}, state, {
                employeeSales: state.employeeSales.map(sale => {
                    // Match on either the synthetic Id ("userId-periodId") or
                    // the WorkPeriodId. WebAPI returns PascalCase, so accept
                    // either casing on both sides. Different navigation paths
                    // (Users tab vs Sales report) build the snapshot from
                    // different APIs that don't share an id format, so
                    // matching by WorkPeriodId is the most reliable route.
                    const saleKey = sale.Id || sale.id;
                    const saleUserId = sale.UserId ?? sale.userId ?? sale.OrderUserId ?? sale.orderUserId;
                    const wpId = sale.WorkPeriodId || sale.workPeriodId
                        || sale.WorkperiodId || sale.workperiodId;
                    const targetSaleId = action.payload.saleId;
                    const targetWpId = action.payload.workPeriodId;
                    const targetUserId = action.payload.userId;

                    const matchesById = saleKey && targetSaleId && saleKey === targetSaleId;
                    const matchesUser = !targetUserId || !saleUserId
                        || Number(saleUserId) === Number(targetUserId);
                    const matchesByWp = wpId && targetWpId
                        && Number(wpId) === Number(targetWpId)
                        && matchesUser;

                    if (matchesById || matchesByWp) {
                        const updated = {
                            ...sale,
                            TipPayoutStatus: action.payload.status,
                        };

                        if (Object.prototype.hasOwnProperty.call(action.payload, 'manualPayReason')) {
                            updated.ManualPayReason = action.payload.manualPayReason;
                        }

                        if (action.payload.status === 'paid') {
                            const tips = parseFloat(sale.Tips ?? sale.tips) || 0;
                            const gratuity = parseFloat(sale.Gratuity ?? sale.gratuity) || 0;
                            const earnings = tips + gratuity;
                            updated.TipsPaidAmount = action.payload.tipsPaidAmount ?? earnings;
                            updated.TipsOwedAmount = action.payload.tipsOwedAmount ?? 0;
                        } else if (action.payload.status === 'partial') {
                            if (action.payload.tipsPaidAmount !== undefined && action.payload.tipsPaidAmount !== null) {
                                updated.TipsPaidAmount = action.payload.tipsPaidAmount;
                            }
                            if (action.payload.tipsOwedAmount !== undefined && action.payload.tipsOwedAmount !== null) {
                                updated.TipsOwedAmount = action.payload.tipsOwedAmount;
                            }
                        }

                        return updated;
                    }
                    return sale;
                })
            });
        default:
            return state;
    }
}
